export default {
  name: 'close',
  icon: {
    tag: 'svg',
    attrs: { viewBox: '0 0 12 12', fill: 'none' },
    children: [
      {
        tag: 'g',
        attrs: {
          id: 'close-group-0',
        },
        children: [
          {
            tag: 'path',
            attrs: {
              d: 'M1 11.0005L11 1.00049M1 1.00049L11 11.0005',
              stroke: 'currentColor',
              strokeWidth: '1.5',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            },
          },
        ],
      },
    ],
  },
}
